"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@emotion/react");
var _Button = _interopRequireDefault(require("../Button"));
var _IconCaretDown = _interopRequireDefault(require("../../icons/General/IconCaretDown"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const Dropdown = ({
  label,
  icon,
  background,
  children,
  triggerClose,
  onCloseTrigger,
  clickOutsideTimeout,
  css,
  className,
  ...restProps
}) => {
  const ref = /*#__PURE__*/(0, _react.createRef)();
  const buttonRef = /*#__PURE__*/(0, _react.createRef)();
  const [open, toggleOpen] = (0, _react.useState)(false);
  const theme = (0, _react2.useTheme)();
  const onClick = function () {
    toggleOpen(!open);
    if (open) {
      setTimeout(() => {
        // If there is a button or an anchor in the dropdown, focus it
        const firtFocusableElement = ref.current?.querySelector('a, button');
        firtFocusableElement?.focus();
      }, 50);
    } else {
      buttonRef.current?.focus();
    }
  };
  (0, _react.useEffect)(() => {
    const handleClickOutside = e => {
      // TODO type
      const node = ref.current;
      if (node && node.contains(e.target)) {
        return;
      }
      if (clickOutsideTimeout !== undefined) {
        setTimeout(() => {
          toggleOpen(false);
        }, clickOutsideTimeout);
      } else {
        toggleOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, ref, clickOutsideTimeout]);
  (0, _react.useEffect)(() => {
    if (triggerClose) {
      toggleOpen(false);
      onCloseTrigger && onCloseTrigger();
    }
  }, [triggerClose, onCloseTrigger]);
  const accessibilityProps = {
    'aria-haspopup': restProps['aria-haspopup'] || 'true',
    'aria-expanded': restProps['aria-expanded'] || open,
    'aria-label': restProps['aria-label'] || 'Dropdown'
  };
  return (0, _jsxRuntime.jsxs)("span", {
    ref: ref,
    role: "button",
    ...accessibilityProps,
    css: theme => [icon && _styles.styles.icon(theme), background && _styles.styles.background(background)],
    children: [(0, _jsxRuntime.jsx)(_Button.default, {
      outline: true,
      ref: buttonRef,
      beforeIcon: icon,
      afterIcon: (0, _jsxRuntime.jsx)(_IconCaretDown.default, {
        flipVertical: open
      }),
      border: open ? theme.primary : undefined,
      onClick: onClick,
      css: css,
      className: className,
      children: label ? label : '- Velg'
    }), open && (0, _jsxRuntime.jsx)("div", {
      css: theme => _styles.styles.default(theme),
      children: children
    })]
  });
};
var _default = exports.default = Dropdown;